import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-star-rating',
  templateUrl: './star-rating.component.html'
})
export class StarRatingComponent implements OnInit {

  @Input() rating: number;
  @Input() class: string;

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /var/www/subdomains/codebnb/hanoigo/public_html/client_user/src/app/star-rating/star-rating.component.ts